import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { gql } from '@apollo/client'
import { apolloClient } from 'lib/apollo'
import { Query, ShopStripePayout } from 'types/graphql'
import { hideLoading, showLoading } from 'reducks/loading/operations'

const useQueryShopPayouts = (shopId: string, limit: number): ShopStripePayout[] => {
  const dispatch = useDispatch()
  const [payouts, setPayouts] = useState<ShopStripePayout[]>([])

  useEffect(() => {
    ;(async () => {
      if (!shopId) return
      const QUERY_PAYOUTS = gql(`
        query {
          shop(id: "${shopId}") {
            id
            name
            stripe {
              payouts(limit: ${limit}) {
                status
                amount
                feeAmount
                arrivalDate
                createdDate
                payoutId
              }
            }
          }
        }
      `)
      dispatch(showLoading())
      const { error, data } = await apolloClient.query<Query>({ query: QUERY_PAYOUTS })
      dispatch(hideLoading())
      if (error) {
        console.error(error)
        return
      }
      if (data?.shop?.stripe?.payouts) {
        setPayouts([...data.shop.stripe.payouts])
      }
    })()
  }, [shopId, limit])

  return payouts
}

export default useQueryShopPayouts
